import React from 'react';
import { Link } from 'react-router-dom';// Ensure Next.js is installed or replace with a standard <a> tag
import {
  Utensils,
  Wrench,
  Wind,
  Home,
  SprayCanIcon as Spray,
  CookingPot,
  Lightbulb,
  Shovel,
  ShowerHeadIcon as Shower,
  ChevronLeft,
  ChevronRight,
} from 'lucide-react'; // Ensure lucide-react is installed

const categories = [
  { name: 'Kitchen Appliances', icon: <Utensils size={24} /> },
  { name: 'Electric Tools', icon: <Wrench size={24} /> },
  { name: 'AC & Cooling', icon: <Wind size={24} /> },
  { name: 'Home Essentials', icon: <Home size={24} /> },
  { name: 'Cleaning Tools', icon: <Spray size={24} /> },
  { name: 'Cookware', icon: <CookingPot size={24} /> },
  { name: 'Smart Home', icon: <Lightbulb size={24} /> },
  { name: 'Outdoor Tools', icon: <Shovel size={24} /> },
  { name: 'Bathroom Fixtures', icon: <Shower size={24} /> },
];

export default function CategoryBrowser() {
  return (
    <section className="my-12">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl md:text-2xl font-bold mb-4 flex items-center text-gray-800">
          <span className="w-1 h-6 bg-[#ff9906] mr-2 inline-block"></span>
          Browse By Category
        </h2>
        <div className="flex space-x-2">
          <button className="p-2 rounded-full border border-gray-200 hover:bg-gray-100 text-gray-600">
            <ChevronLeft size={20} />
          </button>
          <button className="p-2 rounded-full border border-gray-200 hover:bg-gray-100 text-gray-600">
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {categories.map((category, index) => (
          <Link
            key={index}
            href={`/category/${category.name.toLowerCase().replace(/['\s&]+/g, '-')}`}
            className="flex flex-col items-center justify-center p-4 bg-white rounded-md shadow-sm hover:shadow-md transition-all border border-gray-100"
          >
            <div className="text-[#ff9906]">{category.icon}</div>
            <span className="mt-2 text-sm text-gray-700">{category.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}